import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';
import { Box, Grid, Button, useMediaQuery, useTheme, Typography } from '@material-ui/core';
import PageSubTitle from '../../components/UI/PageSubTitle';
import DiscountCard from '../../components/Cards/DiscountCard';
import { useStores } from '../../hooks/use-stores';
import Loader from '../../components/Loader';
import ProductCardType2 from '../../components/ProductCards/ProductCardType2';

const Discounts = observer(() => {
    const { DiscountStore: store } = useStores();

    const theme = useTheme();
    const isSM = useMediaQuery(theme.breakpoints.down('sm'));

    // Effects
    useEffect(() => {
        store.getDiscounts();
    }, [store]);

    useEffect(() => {
        store.getRegionOffers();
    }, [store]);

    // Renders
    const renderRegionOffers = () => {
        return store.regionOffers.map((item, i) => (
            <Grid key={item.id} item xs={12} sm={6} lg={4}>
                <ProductCardType2 data={item} onToggleFavorite={store.toggleFavorite} />
            </Grid>
        ));
    };

    return (
        <>
            <PageSubTitle>Скидка на вакуумное оборудование</PageSubTitle>
            <Box mb={7}>
                <Grid container spacing={3}>
                    <Grid item xs={12} sm={6} md={4}>
                        <DiscountCard type="current" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <DiscountCard type="future" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <DiscountCard type="rentDays" />
                    </Grid>
                </Grid>
            </Box>

            <Box mb={7}>
                <PageSubTitle>Ваш уровень</PageSubTitle>
                {store.loading && <Loader />}
                {!store.loading && store.levels?.length ? (
                    <div className="privilege privilege--v3">
                        <div className="privilege__col">
                            <div className="privilege-type">
                                <div className="privilege-type__icon">
                                    <img src={store.userLevelInfo?.image_available} alt="" className="sprite-icon" />
                                </div>
                                <div className="privilege-type__text">
                                    <div className="privilege-type__title">{store.userLevelInfo?.name}</div>
                                    <div className="privilege-type__desc">{store.userLevelInfo?.points} баллов</div>
                                </div>
                            </div>
                        </div>
                        <div className="privilege__col">
                            <div className="privilege__desc">
                                <Box mb={{ xxs: 2, md: 4 }}>
                                    <Typography>{store.userLevelInfo?.level_description}</Typography>
                                </Box>

                                <Grid container spacing={isSM ? 1 : 2} justify={isSM ? 'center' : 'flex-start'}>
                                    <Grid item>
                                        <Link to="/loyalty#privilage">
                                            <Button variant="outlined" color="primary" size="small">
                                                Привилегии
                                            </Button>
                                        </Link>
                                    </Grid>
                                    <Grid item>
                                        <Link
                                            to={{
                                                pathname: '/loyalty',
                                                hash: '#faq',
                                                state: { activeTabID: 0 },
                                            }}
                                        >
                                            <Button variant="outlined" color="primary" size="small">
                                                получить бонусы
                                            </Button>
                                        </Link>
                                    </Grid>
                                    <Grid item>
                                        <Link
                                            to={{
                                                pathname: '/loyalty',
                                                hash: '#faq',
                                                state: { activeTabID: 1 },
                                            }}
                                        >
                                            <Button variant="outlined" color="primary" size="small">
                                                потратить баллы
                                            </Button>
                                        </Link>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>
                    </div>
                ) : null}
            </Box>

            <Box mb={10}>
                <PageSubTitle>Акции в вашем регионе</PageSubTitle>
                <Grid container spacing={5}>
                    {store.regionOfferLoading && <Loader />}
                    {!store.regionOfferLoading && store.regionOffers?.length ? renderRegionOffers() : null}
                </Grid>
            </Box>
        </>
    );
});

export default Discounts;
